export default __webpack_public_path__ + "static/media/search.2bef60f0.svg";